export default __webpack_public_path__ + "static/media/video-call-disconnect.6d033451.mp3";